/* eslint-disable max-len */
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import firmwaresAction from '@state/firmware/actions';
import devicesApi from '@api/devicesApi';
// import isEmpty from 'lodash/isEmpty';

function useCreateFirmwares() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const dataInit = useSelector(({ firmwares }) => firmwares.createNewFirmware);
  const idToEdit = useSelector(({ firmwares }) => firmwares.firmwareIdToEdit);
  const [dataForm, setDataForm] = useState(dataInit);
  const abortC = new AbortController();
  const { signal } = abortC;
  // const body = useSelector(({ device: a }) => a.createNewDevice);

  const [loadingSave, setLoadingSave] = useState(false);

  const currentUserRol = useSelector(({ user }) => user.role);
  const [businessData, setBusinessData] = useState([]);

  const defaultData = {
    segment: '',
    version: '',
    fw_url: '',
    fw_crc: '',
  };

  const onFinish = useCallback((values) => { // submit: create device or edit device

    if (!idToEdit) { //  create device

      const formData = new FormData();
      formData.append('firmware_file', dataInit.fw_url);
      formData.append('segment', dataInit.segment);
      formData.append('version', dataInit.version);

      const { busines_id } = dataInit;

      setLoadingSave(true);
      devicesApi.createFirmware({ signal, formData, busines_id })
        .then((response) => {

          setLoadingSave(false);
          message.success(t('views.create_firmwares.form.create_success'));
          setDataForm(defaultData);
          dispatch(firmwaresAction.setCreateEditFirmwares(defaultData));
          dispatch(firmwaresAction.setFirmwaresIdEdit(null));

          history.push('/dispositivos/administrar/firmware');

        })
        .catch((resError) => {

          setLoadingSave(false);
          message.error(t('views.create_firmwares.form.create_error'));

        });

    } else { // Edit Device

      const formData = new FormData();
      formData.append('firmware_file', dataInit.fw_url);
      formData.append('segment', dataInit.segment);
      formData.append('version', dataInit.version);

      setLoadingSave(true);
      devicesApi.editFirmwareData({ signal, id: idToEdit, formData })
        .then((response) => {

          setLoadingSave(false);

          message.success('Editado');
          // eslint-disable-next-line
          console.log(response);
          setDataForm(defaultData);
          dispatch(firmwaresAction.setCreateEditFirmwares(defaultData));
          dispatch(firmwaresAction.setFirmwaresIdEdit(null));
          history.push('/dispositivos/administrar/firmware');

        })
        .catch((resError) => {

          setLoadingSave(false);

          message.error('Error al editar Firmware');
          // eslint-disable-next-line
          console.log(resError);

        });

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const fileRequest = useCallback(
    ({ file, onSuccess, onProgress }) => {

      let progress = 0;
      const interval = setInterval(() => {

        progress += 10;

        onProgress({ percent: progress });
        if (progress === 100) {

          onSuccess('ok');
          clearInterval(interval);
          setDataForm({ ...dataForm, fw_url: file });
          dispatch(firmwaresAction.setCreateEditFirmwares({ ...dataForm, fw_url: file }));
          progress = 0;

        }

      }, 150);

    }, [dispatch, dataForm, setDataForm],
  );

  const changeFile = (info) => {

    if (info.file.status === 'done') {

      message.success(`${info.file.name} file uploaded successfully`);

    } else if (info.file.status === 'error') {

      message.error(`${info.file.name} file upload failed.`);

    }

  };

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);
      // if (key === 'name') valueName = data;
      setDataForm({ ...dataForm, [key[0]]: data[0] });
      // eslint-disable-next-line max-len
      dispatch(firmwaresAction.setCreateEditFirmwares({ ...dataForm, [key[0]]: data[0] }));

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const readBusinessType = useCallback(async () => {

    const skip = 0;
    const limit = 1000;

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

          const newBusiness = await Promise.all(business.map(async (obj) => {

            const item = {
              value: obj.id,
              label: obj.name,
              devices: obj.total_general,
              clients: obj.total_general_clients,
              type: obj.type,
            };
            return item;

}));

          setBusinessData(newBusiness);

      }).catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          console.log('fem ', fem);

      });

  });

  const cancelCreateEditDevice = useCallback(
    () => {

      history.push('/dispositivos/administrar/firmware');

    },
    // eslint-disable-next-line
    [],

  );

  useEffect(() => { // mount component

    readBusinessType();

    if (!idToEdit && location.pathname === '/dispositivos/firmware/editar-firmware') {

      // If trying to edit without idToEdit, redirect to tipo-negocio
        history.push('/dispositivos/administrar/firmware');

    } else if (!idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

      // If trying to create without idToEdit and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/dispositivos/administrar/firmware');

}
    return function cleanUp() {

      dispatch(firmwaresAction.setCreateEditFirmwares(defaultData));
      dispatch(firmwaresAction.setFirmwaresIdEdit(null));

    };
  // eslint-disable-next-line
  }, [idToEdit]);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
    fileRequest,
    changeFile,
    businessData,
    loadingSave,
  };

}

export default useCreateFirmwares;
